module.exports = __webpack_public_path__ + "img/menu-bar.96e833be.png";